const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "Mar 2022" from a YYYY-MM-DD or YYYY-MM date. */
export function monthLabel(date: string): string {
  const [y, m] = date.split('-').map(Number);
  return `${MONTHS[(m || 1) - 1]} ${y}`;
}

/** Whole months from one date to another (by calendar month). */
export function monthsBetween(from: string, to: string): number {
  const [fy, fm, fd] = from.split('-').map(Number);
  const [ty, tm, td] = to.split('-').map(Number);
  return Math.max(0, (ty - fy) * 12 + (tm - fm) - ((td || 1) < (fd || 1) ? 1 : 0));
}

/** "2 yr 7 mo", "5 mo", or "under a month". */
export function durationLabel(months: number): string {
  if (months < 1) return 'under a month';
  const years = Math.floor(months / 12);
  const rest = months % 12;
  return [years ? `${years} yr` : '', rest ? `${rest} mo` : ''].filter(Boolean).join(' ');
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
